import {Component, Input, QueryList, ViewChildren} from '@angular/core';
import {Machine} from '@models/machine/machine';
import {
  SortEvent,
  TableHeaderSortableDirective
} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'scitis-admin-organization-machines',
    templateUrl: './machines.component.html',
    styleUrls: ['./machines.component.scss'],
    standalone: false
})
export class MachinesComponent {


  @Input()
  machines: Machine[] = new Array<Machine>();

  @Input()
  organizationName: string = '';

  constructor(private tableHeaderSortableService: TableHeaderSortableService,
              public translate: TranslateService) {
  }


  //SORTING
  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.machines = this.tableHeaderSortableService.sortItems<Machine>(this.machines, column, direction);
  }
}
